import { Component, signal, WritableSignal } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { SalisburyDosingComponent } from './salisbury-dosing/salisbury-dosing.component';
import { DailyDosingComponent } from './daily-dosing/daily-dosing.component';
import { MatCardModule } from "@angular/material/card";

@Component({
  selector: 'app-daily-dosing-tabs',
  imports: [MatTabsModule, DailyDosingComponent, SalisburyDosingComponent, MatCardModule],
  templateUrl: './daily-dosing-tabs.component.html',
  styleUrl: './daily-dosing-tabs.component.scss'
})
export class DailyDosingTabsComponent {
activeTabIndex: WritableSignal<number> = signal(0);
}
